export default __webpack_public_path__ + "static/media/opencv.1de13356.svg";